import React, { useEffect, useState } from "react";
import RemarksApi from "../../Api/RemarksApi";

function ModelssueRemarkList(props) {

    const { onUpdate, setTemplateData } = props;

    const [remarks, setRemarks] = useState([]);
    const [selectedRemarkId, setSelectedRemarkId] = useState(null);

    const fetchTemplateData = async () => {
        const response = await RemarksApi.GetAllRemarks();
        if (response.StatusCode === 200) {
            console.log("response", response);
            setRemarks(response.Result);
        }
    }

    useEffect(() => {
        fetchTemplateData();
    }, []);

    const handleSelection = (id, title, description) => {
        setSelectedRemarkId(id);
        setTemplateData({ title, description });
    }
    const handleTitleClick = (remark) => {
        handleSelection(remark.id, remark.Title, remark.Description);
    };

    return (
        <div>
            <div className="">
                {remarks && remarks.map(remark => (
                    <div
                        key={remark.id}
                        className="flex-remark-list"
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="checkbox-Issue">
                            <input
                                type="radio"
                                name="remarkSelection"
                                className="input-radio-issue"
                                checked={selectedRemarkId === remark.id}
                                onChange={() => handleSelection(remark.id, remark.Title, remark.Description)}
                            />
                        </div>

                        {/* Clickable Title Area */}
                        <div
                            className="input-content-remarkList"
                            onClick={() => handleTitleClick(remark)}
                            style={{ flex: 1, userSelect: 'none' }}
                            dangerouslySetInnerHTML={{ __html: remark.Title }}
                        />
                    </div>
                ))}

                <hr />
                <div className="Save-flex-btn">
                    <button className="temp-save" onClick={onUpdate}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModelssueRemarkList;